import React from "react";
import Box from '@mui/material/Box';
import Product from "./Product";
import {api} from "./../../services/ResourceService";

export default function Products(){
	const [products, setProducts] = React.useState([]);
	React.useEffect(()=>{
		(async()=>{
			const res = await api.get("/products").catch(err=>{console.log(err); return []});
			setProducts(res);
		})();		
	}, []);
	return (
		<Box sx={{ width: "100%" }}>
	        {products.map((p, i) =>(<Product key={i} product={p} property={{}} />))}
	    </Box>
	)
}